import { createContext, useContext } from "react";

/**
 * PresenceContext — Shares presence state from Layout to all children.
 * Avoids duplicate WebSocket connections.
 */
const PresenceContext = createContext({ onlineUsers: [], sendCursor: () => {}, sendTyping: () => {} });

export const PresenceProvider = PresenceContext.Provider;
export const usePresenceContext = () => useContext(PresenceContext);
